"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SankeyDevMenuDataPercent = exports.devGetLinkValue = void 0;
const react_1 = __importDefault(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const SankeyDrawFunction_1 = require("open-sankey/dist/SankeyDrawFunction");
/**
 * Return link value, determined by selected dataTag (if there is)
 * Sometime the link can be duplicate when we choose to select multiple dataTag
 * therefore to access the right value of the link we search in the id the right value
 */
const devGetLinkValue = (data, idLink, up = false) => {
    const { links, dataTags } = data;
    // Split the id and search for value after the original link id
    //  each value represent wich dataTag to choose among those where selected is at true in link.value 
    // If there no dataTag (or no multiple dataTag selected then it take the first selected)
    const idDt = idLink.split('_');
    idDt.splice(0, 1);
    const defaultInd = Object.values(data.dataTags)
        .map(d => {
        return Object.values(d.tags).filter(t => t.selected).map((dd, i) => i)[0];
    });
    const index_dataTag = (idDt.length == 0) ? defaultInd : idDt.map(d => Number(d));
    if (!(idLink in links)) {
        return {
            value: 0,
            display_value: '',
            is_percent: false,
            percent: 0,
            tags: {},
            extension: {}
        };
    }
    let val = links[idLink].value;
    const listKey = [];
    let missing_key = false;
    Object.values(dataTags).filter(dataTag => { return (Object.keys(dataTag.tags).length != 0) ? true : false; }).forEach((dataTag, i) => {
        const selected_tags = Object.entries(dataTag.tags).filter(([, tag]) => { return tag.selected; });
        if (selected_tags.length == 0 || missing_key) {
            missing_key = true;
            return;
        }
        listKey.push(Object.entries(dataTag.tags).filter(([, tag]) => { return tag.selected; })[index_dataTag[i]][0]);
    });
    if (missing_key) {
        return {
            value: 0,
            display_value: '',
            tags: {},
            is_percent: false,
            percent: 0,
            extension: {}
        };
    }
    for (const i in listKey) {
        if (up && +i === (listKey.length - 1)) {
            break;
        }
        val = val[listKey[i]];
        if (val === undefined) {
            return {
                value: 0,
                display_value: '',
                tags: {},
                is_percent: false,
                percent: 0,
                extension: {}
            };
        }
    }
    return val;
};
exports.devGetLinkValue = devGetLinkValue;
const SankeyDevMenuDataPercent = (data, set_data, multi_selected_links, tags_selected, selected_link) => {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_bootstrap_1.Row, null,
            react_1.default.createElement(react_bootstrap_1.Col, null,
                react_1.default.createElement(react_bootstrap_1.FormCheck, { type: 'checkbox', checked: SankeyDrawFunction_1.value_selected_parameter(data, multi_selected_links, tags_selected).is_percent, label: 'Valeur proportionnelle \u00E0 la valeur du noeuds source', onChange: evt => {
                        let val = Object(selected_link.current.value);
                        multi_selected_links.current.map(d => {
                            val = d.value;
                            Object.values(tags_selected).forEach(tag => {
                                if (val[tag] === undefined) {
                                    val[tag] = {};
                                }
                                val = val[tag];
                            });
                            val.is_percent = evt.target.checked;
                        });
                        set_data(Object.assign({}, data));
                    } }))),
        react_1.default.createElement(react_bootstrap_1.Row, null,
            react_1.default.createElement(react_bootstrap_1.Col, { xs: 3 },
                react_1.default.createElement(react_bootstrap_1.FormLabel, { style: { color: (SankeyDrawFunction_1.value_selected_parameter(data, multi_selected_links, tags_selected).is_percent) ? '#555555' : '#DADADA' } }, "Pourcent")),
            react_1.default.createElement(react_bootstrap_1.Col, { xs: 3 },
                react_1.default.createElement(react_bootstrap_1.FormLabel, { style: { color: (SankeyDrawFunction_1.value_selected_parameter(data, multi_selected_links, tags_selected).is_percent) ? '#555555' : '#DADADA' } }, SankeyDrawFunction_1.value_selected_parameter(data, multi_selected_links, tags_selected).percent)),
            react_1.default.createElement(react_bootstrap_1.Col, null,
                react_1.default.createElement(react_bootstrap_1.Form.Range, { disabled: !SankeyDrawFunction_1.value_selected_parameter(data, multi_selected_links, tags_selected).is_percent, value: SankeyDrawFunction_1.value_selected_parameter(data, multi_selected_links, tags_selected).percent, onChange: evt => {
                        let val = Object(selected_link.current.value);
                        multi_selected_links.current.map(d => {
                            const src_value = getTotalInputLink(data, data.nodes[d.idSource], exports.devGetLinkValue);
                            val = d.value;
                            Object.values(tags_selected).forEach(tag => {
                                if (val[tag] === undefined) {
                                    val[tag] = {};
                                }
                                val = val[tag];
                            });
                            val.percent = +evt.target.value;
                            val.value = src_value * (val.percent / 100);
                        });
                        set_data(Object.assign({}, data));
                    } })))));
};
exports.SankeyDevMenuDataPercent = SankeyDevMenuDataPercent;
/**
* Return the sum of links value visible incoming to the node
*
* @param {SankeyData} data
* @param {SankeyNode} node
* @returns {number}
*/
const getTotalInputLink = (data, node, getLinkValue) => {
    let total = 0;
    node.inputLinksId.forEach(element => {
        // On vérifie que le lien est affiché, cad que le noeud source et le noeud target sont
        if (data.nodes[data.links[element].idSource].node_visible && data.nodes[data.links[element].idTarget].node_visible) {
            const tmp = getLinkValue(data, element).value;
            total += (tmp) ? tmp : 0;
        }
    });
    return total;
};
